import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/it-operation-core/anchor-date')({});